module.exports = __webpack_public_path__ + "static/media/cldc2016_program.82ea6181.pdf";